module.exports = __webpack_public_path__ + "assets/snapchat.bff43558.svg";